import React from 'react';
import { Box, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Login from './Login';
import Signup from './Signup';
import Footer from '../Footer/Footer';

const LoginPage: React.FC = () => {
  const location = useLocation();
  const isLoginPath = location.pathname === '/login';

  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 71px)',
        position: 'relative',
        overflow: 'hidden' // Prevents the logo from creating scrollbars
      }}
    >
      {/* Background logo */}
      <Box 
        component="img"
        src="/UnitedInTalk_Logo_Flag.svg"
        alt="United In Talk Logo"
        sx={{
          position: 'absolute',
          top: '50%',
          scale: 1.5,
          left: '50%',
          transform: 'translate(-95%, -57%)',
          height: '80%',
          maxWidth: '90%',
          opacity: 0.20, 
          zIndex: 0, 
          pointerEvents: 'none' // Ensures clicks pass through to elements below
        }}
      />
      
      {/* Content wrapper - takes all available space except footer */}
      <Box 
        sx={{ 
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            width: '100%',
            px: { xs: 0, sm: 0, md: '10%', lg: '17%', xl: '17%' },
            // Alternative approach with asymmetric padding
            // pl: { xs: 2, sm: 4, md: '15%', lg: '25%' },
            // pr: { xs: 2, sm: 4, md: '5%', lg: '15%' },
        }}
        >
        {/* Main content */}
        <Container 
          maxWidth="sm" 
          sx={{ 
            mt: 8, 
            mb: 4,
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
            position: 'relative',
            zIndex: 1 // Ensures content is above the background logo
          }}
        >
          {/* Conditionally render Login or Signup based on path */}
          {isLoginPath ? <Login /> : <Signup />}
        </Container>
      </Box>
      
      {/* Footer as a separate flex item */}
      <Box sx={{width: '100%', margin: 'auto',}}>
        <Footer />
      </Box>
    </Box>
  );
};

export default LoginPage;